module.exports = __webpack_public_path__ + "static/media/folder-times.36e7da7f.svg";